import { styled } from '../../../../base';

export const StepIconRoot = styled('div')(({ theme }) => ({
    zIndex: 2,
    color: theme.palette.primary.main,
    width: 40,
    height: 40,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    border: `2px solid ${theme.palette.primary.main}`,
    position: 'relative',
}));
